import React from 'react';
function StarRow() {
  return <div className="flex gap-1" data-id="element-206">
      {[1, 2, 3, 4, 5].map(i => <svg key={i} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-207">
          <path d="M10 1.5L12.47 6.97L18.5 7.64L13.98 11.66L15.27 17.56L10 14.52L4.73 17.56L6.02 11.66L1.5 7.64L7.53 6.97L10 1.5Z" fill="#FFB649" stroke="#FFB649" strokeWidth="0.83" data-id="element-208" />
        </svg>)}
    </div>;
}
interface ReviewProps {
  title: string;
  body: string;
  author: string;
  date?: string;
}
function Review({
  title,
  body,
  author,
  date
}: ReviewProps) {
  return <div className="flex flex-col" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-209">
      <StarRow data-id="element-210" />
      <h3 className="font-bold mt-3" style={{
      fontSize: 18,
      lineHeight: '27px',
      color: '#1A1A1A'
    }} data-id="element-211">
        {title}
      </h3>
      <p className="mt-2" style={{
      fontSize: 15,
      lineHeight: '22.5px',
      color: '#1A1A1A'
    }} data-id="element-212">
        {body}
      </p>
      <div className="flex items-center gap-2 mt-2" data-id="element-213">
        <span className="font-light" style={{
        fontSize: 14,
        lineHeight: '19.6px',
        color: '#1A1A1A',
        opacity: 0.8
      }} data-id="element-214">
          {author}
        </span>
        {date && <span className="font-light" style={{
        fontSize: 14,
        lineHeight: '19.6px',
        color: '#1A1A1A',
        opacity: 0.48
      }} data-id="element-215">
            {date}
          </span>}
      </div>
    </div>;
}
export function ReviewsSection() {
  return <section className="w-full bg-white" style={{
    padding: '48px 48px',
    fontFamily: 'Inter, sans-serif'
  }} aria-label="Kundenbewertungen" data-id="element-216">
      <div className="flex flex-col" style={{
      gap: 40
    }} data-id="element-217">
        <Review title="Ergebnisse sichtbar!" body="Ich habe nun nach acht Wochen regelmäßige Anwendung einer Reduzierung der Faltengröße und eine strafere Form festgestellt. Demnach bin ich zufrieden!" author="– Christoph" date="10/16/2025" data-id="element-218" />
        <Review title="Sehr zufrieden" body="Ich habe schon viele Produkte getestet die meisten Produkte Vertrage ich einfach nicht, da ich eine sehr empfindliche Haut habe. Bei den Produkten von MaleUp habe ich überhaupt keine Probleme. Weder die Creme noch das Serum verursachen Rötungen oder Irritationen." author="– Steffen G." date="10/01/2025" data-id="element-219" />
        <Review title="Falten Killer" body="Bin sehr zufrieden mit dem Ergebnis nach dem 1. Monat, weniger Falten an den Augen und im Ganzen wirkt man etwas frischer im Gesicht. Tip Top" author="– Michael" data-id="element-220" />
        <Review title="Super Produkt" body="Sicherlich, ist das Produkt etwas teurer, als andere von dm oder ähnlichen Anbietern. Aber meiner Meinung nach ist es das Geld wert." author="– Dick Kamphof" date="09/23/2025" data-id="element-221" />
      </div>
    </section>;
}